import Swiper from 'swiper';
import { Navigation, Pagination, EffectCoverflow } from 'swiper/modules';

export const initSlider = () => {
  // Case Study Slider
  new Swiper('.case-study-slide', {
    modules: [Navigation, Pagination, EffectCoverflow],
    loop: false,
    grabCursor: true,
    slidesPerView: 3,
    autoplay: {
      delay: 3000
    },
    spaceBetween: -234,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".hm-case-study-next",
      prevEl: ".hm-case-study-prev"
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      767: {
        spaceBetween: -350,
      },
    },
  });

  // Diğer sliderlar için genel yapı
  const sliders = document.querySelectorAll('.swiper:not(.case-study-slide)');
  
  sliders.forEach(slider => {
    new Swiper(slider, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });
  });
  if(window.innerWidth <= 767) {
    new Swiper('.point-difference-list', {
      modules: [Navigation, Pagination],
      grabCursor: true,
      slidesPerView: 1.1,
      spaceBetween: 15,
    });
  }
  
  if(window.innerWidth <= 767) {
    new Swiper('.home-news-list', {
      modules: [Navigation, Pagination],
      grabCursor: true,
      slidesPerView: 1.1,
      spaceBetween: 15,
    });
  }
}; 